import Handlebars from 'handlebars';

globalThis.Handlebars = Handlebars;
